import PropTypes from 'prop-types';

import {
  ThemeProvider,
  CookiesProvider,
  ToastContainer,
  UserInfoProvider,
  FooterSimplified,
  GenericErrorContent,
  AppBanner
} from '@spotahome/ui-library';

import LoginModal from '../login/LoginModal';
import HeaderComponent from '../Header';

const NotFound = ({ initialCookie, deviceType, error }) => (
  <CookiesProvider initialCookie={initialCookie}>
    <ThemeProvider flags={{ newButtons: true }}>
      <UserInfoProvider>
        <ToastContainer />
        <AppBanner source="seo" deviceType={deviceType} />
        <HeaderComponent deviceType={deviceType} />
        <GenericErrorContent
          title="error_page.not_found.h1"
          subtitle="error_page.not_found.content"
          errorCode={error === 'gone' ? 410 : 404}
        />
        <FooterSimplified />
        <LoginModal />
      </UserInfoProvider>
    </ThemeProvider>
  </CookiesProvider>
);

NotFound.propTypes = {
  initialCookie: PropTypes.string.isRequired,
  deviceType: PropTypes.oneOf(['smartphone', 'tablet', 'desktop']).isRequired,
  error: PropTypes.oneOf(['notFound', 'gone']).isRequired
};

export default NotFound;
